<template>
  <div class="wrapper box box_v">
    <!-- 头部标题 -->
    <div class="header-wrapper">
      <div class="left">
        <div class="iconfont icon-fanhui2" style="font-size:35px" @click="goback"></div>
      </div>
      <div class="header">实名认证设置</div>
      <div class="newvote">
        <Button class="btn-dc" type="primary" @click="setConfig">发布</Button>
      </div>
    </div>
    <div class="content box box_f1">
      <Card style="width: 100%">
        <div class="title1">
          基本信息
        </div>
        <CheckboxGroup  v-model="group">
          <div class="item" v-for="(item, index) in inputList" :key="index">
            <Checkbox :label="index" :disabled="item.isEditCheckbox == 0 ? true : false">必填</Checkbox>
            <Input
              :placeholder="item.fieldName? item.fieldName : '请输入'"
              :disabled="item.isEditInput == 0 ? true : false"
              v-model="item.fieldName"
              class
              v-if="!item.type"
              style="width: 360px;"
            >{{item.fieldName}}</Input>
            <Select v-model="item.model" v-if="item.type == 'select'" style="width:360px">
              <Option
                v-for="_item in dictionaryBase"
                :value="_item.label"
                :key="_item.label"
              >{{ _item.label }}</Option>
            </Select>
            <span
              v-if="item.fieldValue == 'phone_no'"
              style="color: #999; margin-left: 30px"
            >*手机号会自动获取居民微信关联的手机号，也可由居民修改</span>
            <i
              class="iconfont icon-shanchu"
              v-if="item.canDelete"
              style="color: #d22b2b;"
              @click="delSel(index)"
            ></i>
            <div
              class="child box"
              v-if="item.children && item.children.length"
              style="margin-top: 20px"
            >
              <div class="box" style="margin-right: 20px">选项</div>
              <div class="box_f1">
                <div class="dy box">
                  <div class="box" style="min-width: 56px;margin-right: 5px">辖区居民</div>
                  <div class="box_f1">
                    <div
                      v-for="(item1, index1) in roleList"
                      :key="index1"
                      v-if="item1.fieldType == 3"
                      style="margin-bottom: 20px"
                    >
                      <CheckboxGroup v-if="showGroup" v-model="group1">
                        <Checkbox
                          :label="index1"
                          :disabled="item1.isEditCheckbox == 0 ? true : false"
                        >必填</Checkbox>
                        <Input
                          :placeholder="item1.fieldName? item1.fieldName : '请输入'"
                          :disabled="item1.isEditInput == 0 ? true : false"
                          v-model="item1.fieldName"
                          class
                          v-if="!item1.type"
                          style="width: 360px;"
                        >{{item1.fieldName}}</Input>
                        <Select v-model="item1.model" v-if="item1.type == 'select'" style="width:360px">
                          <Option
                            v-for="_item in dictionary"
                            :value="_item.label"
                            :key="_item.label"
                          >{{ _item.label }}</Option>
                        </Select>
                        <i
                          class="iconfont icon-shanchu"
                          v-if="item1.canDelete"
                          style="color: #d22b2b;"
                          @click="delSel1(index1)"
                        ></i>
                      </CheckboxGroup>
                      
                    </div>
                    <div class="add-con" @click="addSelect1(3)" style="margin-bottom: 20px">
                        <i class="iconfont icon-tianjiajiahaowubiankuang" style="font-size: 14px"></i>
                        <span>添加选项</span>
                    </div>
                  </div>
                </div>
                <div class="dy box">
                  <div class="box" style="margin-right: 20px">志愿者</div>
                  <div class="box_f1">
                    <div
                      v-for="(item1, index1) in roleList"
                      :key="index1"
                      v-if="item1.fieldType == 5"
                      style="margin-bottom: 20px"
                    >
                      <CheckboxGroup v-if="showGroup" v-model="group1">
                        <Checkbox
                          :label="index1"
                          :disabled="item1.isEditCheckbox == 0 ? true : false"
                        >必填</Checkbox>
                        <Input
                          :placeholder="item1.fieldName? item1.fieldName : '请输入'"
                          :disabled="item1.isEditInput == 0 ? true : false"
                          v-model="item1.fieldName"
                          class
                          v-if="!item1.type"
                          style="width: 360px;"
                        >{{item1.fieldName}}</Input>
                        <Select v-model="item1.model" v-if="item1.type == 'select'" style="width:360px">
                          <Option
                            v-for="_item in dictionary"
                            :value="_item.label"
                            :key="_item.label"
                          >{{ _item.label }}</Option>
                        </Select>
                        <i
                          class="iconfont icon-shanchu"
                          v-if="item1.canDelete"
                          style="color: #d22b2b;"
                          @click="delSel1(index1)"
                        ></i>
                      </CheckboxGroup>
                    </div>
                    <div class="add-con" @click="addSelect1(5)" style="margin-bottom: 20px">
                        <i class="iconfont icon-tianjiajiahaowubiankuang" style="font-size: 14px"></i>
                        <span>添加选项</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CheckboxGroup>
        <div class="add-con" @click="addSelect">
          <i class="iconfont icon-tianjiajiahaowubiankuang" style="font-size: 14px"></i>
          <span>添加选项</span>
        </div>
        <div class="title1" style="margin-top: 30px;">
          补充信息<i class="_title">（提交基本认证信息后由居民决定是否继续完善信息）</i>
        </div>
        <CheckboxGroup v-model="group2">
          <div class="item" v-for="(item, index) in buchongList" :key="index">
            <Checkbox :label="index" :disabled="item.isEditCheckbox == 0 ? true : false">必填</Checkbox>
            <Input
              :placeholder="item.fieldName? item.fieldName : '请输入'"
              :disabled="item.isEditInput == 0 ? true : false"
              v-model="item.fieldName"
              class
              v-if="!item.type"
              style="width: 360px;"
            >{{item.fieldName}}</Input>
            <Select v-model="item.model" v-if="item.type == 'select'" style="width:360px">
              <Option
                v-for="_item in dictionary"
                :value="_item.label"
                :key="_item.label"
              >{{ _item.label }}</Option>
            </Select>
            <i
              class="iconfont icon-shanchu"
              v-if="item.canDelete"
              style="color: #d22b2b;"
              @click="delSel2(index)"
            ></i>
          </div>
        </CheckboxGroup> 
        <div class="add-con" @click="addSelect2">
          <i class="iconfont icon-tianjiajiahaowubiankuang" style="font-size: 14px"></i>
          <span>添加选项</span>
        </div>
        <Spin fix v-if="spinShow"></Spin>
      </Card>
    </div>
    <!-- modal -->
    <Modal v-model="showDel" title="删除配置项" @on-ok="ok">
      <p>此操作将删除您实名认证时所填信息，是否删除?</p>
    </Modal>
    <Modal v-model="showDel1" title="删除配置项" @on-ok="ok1">
      <p>此操作将删除您实名认证时所填信息，是否删除?</p>
    </Modal>
    <Modal v-model="showDel2" title="删除配置项" @on-ok="ok2">
      <p>此操作将删除您实名认证时所填信息，是否删除?</p>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      group: [],
      group1: [],
      group2: [],
      group3: [],
      inputList: [],
      spinShow: false,
      delIndex: "",
      showDel: false,
      showDel1: false,
      showDel2: false,
      subList: [],
      dictionary: [],
      dictionaryBase: [],
      roleList: [],
      buchongList: [],
      showGroup:true
    };
  },
  methods: {
    goback() {
      this.$router.push({ name: "miniProgram", query: { state: 1 } });
    },
    change(val) {
      // console.log(val);
      console.log(this.group)
      console.log(this.group1)
    },
    addSelect() {
      this.inputList.push({
        isMust: false,
        noEditable: false,
        model: "",
        type: "select",
        canDelete: true
      });
      this.showGroup = false
      this.$nextTick(()=>{
        this.showGroup = true
      })
    },
    addSelect1(val) {
      this.roleList.push({
        isMust: false,
        noEditable: false,
        model: "",
        type: "select",
        canDelete: true,
        fieldType: val
      });
    },
    addSelect2() {
      this.buchongList.push({
        isMust: false,
        noEditable: false,
        model: "",
        type: "select",
        canDelete: true,
        fieldType: 2
      });
    },
    ok() {
      console.log("shanchu");
      this.spinShow = true;
      var url = this.urlobj.delConfig + '?idList=' + this.inputList[this.delIndex].id
      this.$delete(url).then(res => {
        this.spinShow = false
        this.inputList = []
        this.roleList = []
        this.buchongList = []
        this.getConfig()
      }).catch(e => {
        this.spinShow = false
      })
    },
    ok1() {
      console.log("shanchu");
      this.spinShow = true;
      var url = this.urlobj.delConfig + '?idList=' + this.roleList[this.delIndex].id
      this.$delete(url).then(res => {
        this.spinShow = false
        this.inputList = []
        this.roleList = []
        this.buchongList = []
        this.getConfig()
      }).catch(e => {
        this.spinShow = false
      })
    },
    ok2() {
      console.log("shanchu");
      this.spinShow = true;
      var url = this.urlobj.delConfig + '?idList=' + this.buchongList[this.delIndex].id
      this.$delete(url).then(res => {
        this.spinShow = false
        this.inputList = []
        this.roleList = []
        this.buchongList = []
        this.getConfig()
      }).catch(e => {
        this.spinShow = false
      })
    },
    delSel(index) {
      this.delIndex = index;
      if (this.inputList[index].id) {
        this.showDel = true;
      } else {
        this.inputList.splice(index, 1);
        var group = [];
        this.inputList.forEach((item, index) => {
          if (item.isRequired) {
            group.push(index);
          }
        });
        this.group = group;
        console.log(this.group);
        this.$Message.success("删除成功");
      }
    },
    delSel1(index) {
      this.delIndex = index;
      if (this.roleList[index].id) {
        this.showDel1 = true;
      } else {
        this.roleList.splice(index, 1);
        var group1 = [];
        this.roleList.forEach((item, index) => {
          if (item.isRequired) {
            group1.push(index);
          }
        });
        this.group1 = group1;
        console.log(this.group1);
        this.$Message.success("删除成功");
      }
    },
    delSel2(index) {
      this.delIndex = index;
      if (this.buchongList[index].id) {
        this.showDel2 = true;
      } else {
        this.buchongList.splice(index, 1);
        var group1 = [];
        this.buchongList.forEach((item, index) => {
          if (item.isRequired) {
            group1.push(index);
          }
        });
        this.group2 = group1;
        console.log(this.group1);
        this.$Message.success("删除成功");
      }
    },
    getConfig() {
      console.log('getConfig',this.$store.state.apptype)
      var url = this.urlobj.getFiledConfig;
      var data = {
        func: "realname",
        appType: this.$store.state.apptype=='ctt'?"ctxf":"xfej"
      };
      this.spinShow = true;
      this.$post(url, data).then(res => {
        if (res.isSucceed) {
          console.log(res);
          var group = [];
          var data1 = res.rows;
          data1.forEach((item, index) => {
            if (item.fieldType == 1) {
              this.inputList.push(item);
            }
            if(item.fieldType == 2) {
              this.buchongList.push(item)
            }
            if (item.fieldValue == "role") {
              this.roleList = item.children;
              item.children.forEach((_item, _index) => {
                if (_item.isRequired == 1) {
                  this.group1.push(_index);
                }
              });
            }
          });
          this.inputList.forEach((item, index) => {
            if (item.isRequired) {
              group.push(index);
            }
          });
          this.buchongList.forEach((item, index) => {
            if (item.isRequired) {
              this.group2.push(index);
            }
          });
          // this.inputList = data1;
          this.group = group;
          this.spinShow = false;
        } else {
          this.$Message.warning(res.message);
          this.spinShow = false;
        }
      });
    },
    setConfig() {
      console.log(this.inputList)
      var list1 = this.inputList.map(item => {
        return {
          id: item.id ? item.id : '',
          fieldType: 1,
          fieldName: item.fieldName ? item.fieldName : item.model,
          isRequired: 0,
          children: (item.children && item.children.length) ? [] : null,
          fieldValue: item.model ? this.dictionaryBase.filter(_item => _item.label == item.model)[0].type : '',
          inputType: item.model ? this.dictionaryBase.filter(_item => _item.label == item.model)[0].inputType : ''
        }
      })
      var list2 = this.roleList.map(item => {
        return {
          id: item.id ? item.id : '',
          fieldType: item.fieldType,
          fieldName: item.fieldName ? item.fieldName : item.model,
          isRequired: 0,
          fieldValue: item.model ? this.dictionary.filter(_item => _item.label == item.model)[0].type : ''
        }
      })
      var list3 = this.buchongList.map(item => {
        if(item.model) {
          console.log(this.dictionary.filter(_item => _item.label == item.model))
        }
        return {
          id: item.id ? item.id : '',
          fieldType: 2,
          fieldName: item.fieldName ? item.fieldName : item.model,
          isRequired: 0,
          fieldValue: item.model ? this.dictionary.filter(_item => _item.label == item.model)[0].type : ''
        }
      })
      this.group.forEach(item => {
        list1[item].isRequired = 1
      })
      this.group1.forEach(item => {
        list2[item].isRequired = 1
      })
      this.group2.forEach(item => {
        list3[item].isRequired = 1
      })
      list1.forEach(item => {
        if(item.children) {
          item.children = list2
        }
      })
      var dataList = [...list1, ...list3]
      console.log(dataList)
      // return
      var url = this.urlobj.fieldConfig;
      dataList.forEach(item => {
        if(!item.fieldName) {
          this.$Message.warning("请选择选项信息");
          return;
        }
      })
      list2.forEach(item => {
        if(!item.fieldName) {
          this.$Message.warning("请选择选项信息");
          return;
        }
      })
      console.log("条件判断完成");
      this.spinShow = true;
      var data = {
        appType: this.$store.state.apptype=='ctt'?"ctxf":"xfej",
        dataList
      }
      this.$post(url, data).then(res => {
        if (res.isSucceed) {
          this.$Message.success("发布成功");
          this.spinShow = false;
          this.inputList = []
          this.roleList = []
          this.buchongList = []
          this.getConfig();
        } else {
          this.$Message.warning(res.message);
          this.spinShow = false;
        }
      }).finally(() => this.spinShow = false);
    },
    getDictionary() {
      let url = this.urlobj.dictionaryList("realname_field");
      this.$get(url).then(res => {
        let list = res.rows.map(item => {
          return {
            label: item.dicName,
            type: item.dicType,
            inputType: item.remark ? JSON.parse(item.remark).inputType : ''
          };
        });
        this.dictionaryBase = list;
        var list1 = res.rows.filter(item => !item.remark)
        list1 = list1.map(item => {
          return {
            label: item.dicName,
            type: item.dicType
          }
        })
        this.dictionary = list1
      });
    }
  },
  mounted() {
    this.getConfig();
    this.getDictionary();
  },
  watch: {
    group(newVal) {
      this.showGroup = false
      this.$nextTick(()=>{
        this.showGroup = true
      })
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  color: #666666;
  overflow: hidden;
  height: 100%;
}
.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;
}
.header {
  font-size: 25px;
  text-align: center;
}
.left {
  position: absolute;
  left: 20px;
  font-size: 22px;
}
.newvote {
  position: absolute;
  right: 20px;
  button {
    width: 80px;
    height: 28px;
    line-height: 13px;
  }
  .btn-dc {
    background-color: #ff7c43;
    border-color: #ff7c43;
  }
}
.content {
  // max-width: 96%;
  margin: 20px;
}
.item {
  // height: 40px;
  line-height: 32px;
  width: 48%;
  margin-bottom: 20px;
}
/deep/ .ivu-input {
  width: 360px;
  color: #333;
}
.add-con {
  font-size: 14px;
  color: #ff7b44;
  border: 1px solid #ff7b44;
  width: 93px;
  height: 26px;
  line-height: 26px;
  border-radius: 5px;
  // text-align: center;
  padding-left: 10px;
  padding-right: 10px;
}
.demo-spin-container {
  display: inline-block;
  width: 200px;
  height: 100px;
  position: relative;
}
.child {
  margin-left: 50px;
}
.title1 {
  font-size: 20px;
  margin-bottom: 20px;
  color: #333;
}
._title {
  font-size: 16px;
  color: #999
}
.icon-shanchu {
  margin-left: 30px;
}
</style>
